import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardsComponent } from './cards/cards.component';
import { ModalComponent } from './modal/modal.component';
import { SearchModalComponent } from './search-modal/search-modal.component';
import { FormsModule } from '@angular/forms';
import { UtilityService } from './utility.service';
import { AdvertisementComponent } from './advertisement/advertisement.component';
import { InfiniteScrollerComponent } from './infinite-scroller/infinite-scroller.component';
import { BannerComponent } from './banner/banner.component';
@NgModule({
  declarations: [
    CardsComponent,
    ModalComponent,
    SearchModalComponent,
    AdvertisementComponent,
    BannerComponent,
    InfiniteScrollerComponent,
  ],
  imports: [CommonModule, FormsModule],
  providers: [UtilityService],
  exports: [
    CardsComponent,
    ModalComponent,
    SearchModalComponent,
    AdvertisementComponent,
    BannerComponent,
    InfiniteScrollerComponent,
  ],
})
export class UtilitiesModule {}
